import Modal from 'bootstrap/js/dist/modal'

document.addEventListener('DOMContentLoaded', function () {
  const externalLinkModal = document.getElementById('externalLinkModal');
  const techServiceUrl = externalLinkModal.getAttribute('data-external-link')
  const techServicesPopup = Modal.getOrCreateInstance('#externalLinkModal')
  const techServiceLinks = document.querySelectorAll(`header a[href^="${techServiceUrl}"], footer a[href^="${techServiceUrl}"]`)
  const okButton = externalLinkModal.querySelector('#okButton')

  const handleExternalLinkClick = (ev) => {
    ev.preventDefault();
    const targetUrl = ev.currentTarget.href

    const handleOkClick = () => {
      techServicesPopup.hide()
      window.location.href = targetUrl
    }

    techServicesPopup.show()
    okButton.addEventListener('click', handleOkClick)

    const onModalClose = () => {
      okButton.removeEventListener('click', handleOkClick)
      techServicesPopup._element.removeEventListener('hidden.bs.modal', onModalClose)
    }

    techServicesPopup._element.addEventListener('hidden.bs.modal', onModalClose)
  }

  techServiceLinks.forEach(link => {
    link.addEventListener('click', handleExternalLinkClick)
  })
})